<template>
	<div>
		<vue-draggable-resizable
			class="element-position-lowerthird "
			:style="style"
			:class="className"
			v-if="status ==='preview' && isCustomBrowser"
			:draggable="status ==='preview' && !item.is_locked && !content.isPosition"
			:resizable="status ==='preview' && !item.is_locked && !content.isPosition"
			:x="content.x"
			:y="content.y"
			:w="content.width"
			:h="content.height"
			@dragstop="onDragstop"
			@resizestop="onResizestop"
			@dragging="onDrag"
			@resizing="onResize"
			:lock-aspect-ratio="isLockRatio"
			:preventActiveBehavior="true"
			:parent="false">
			<div :style="styleWithCroppingOuter" v-if="!errorIframePreview">
				<div class="p-8 text-center w-100 mt-2 color-white" v-if="!showIframePreview && !errorIframePreview">
					<div class="is-loading loading-iframe"></div>
				</div>
				<iframe
					:style="styleWithCropping"
					:id="customPageId"
					scrolling="no"
					:src="url"
					:width="content.width"
					v-show="showIframePreview"
					@load="showOnLoadPreview"
					allow="autoplay"
					ref="iframePreviewCustBrowser"
				/>
				<div v-show="isShowLabel" class="text-center label-custom-browser" :style="{ zIndex: localItem.layer_index + 1, fontSize: content.width / 80 + 'px'}">
					<div>{{localItem && localItem.name ? localItem.name : "Default custom browser"}}</div>
				</div>
			</div>
			<div v-if="errorIframePreview" class="container-error-cb">
				<div class="content-error-cb">
					Snap! something is not right, your client does not have permission to get URL from this server
				</div>
			</div>
		</vue-draggable-resizable>
		<div v-if="status ==='live' && isCustomBrowser && !errorIframeLive" :style="styleOutlineLive">
			<div :style="styleWithCroppingOuter" v-if="status ==='live' && isCustomBrowser">
				<div class="p-8 text-center w-100 mt-2 color-white" v-if="!showIframeLive && !errorIframeLive">
					<div class="is-loading loading-iframe"></div>
				</div>
				<iframe
					v-if="status ==='live' && isCustomBrowser"
					:style="styleLive"
					:id="customPageId"
					scrolling="no"
					:src="url"
					class="element-position"
					:width="content.width"
					height="auto"
					:class="className"
					v-show="showIframeLive"
					@load="showOnLoadLive"
					allow="autoplay"
					ref="iframeLiveCustBrowser"
				/>
				<div v-show="isShowLabel" class="text-center label-custom-browser" :style="{ zIndex: localItem.layer_index + 1, fontSize: content.width / 80 + 'px'}">
					<div>{{localItem && localItem.name ? localItem.name : "Default custom browser"}}</div>
				</div>
			</div>
		</div>
		<!-- Video Element -->
	</div>
</template>

<script>
import VueDraggableResizable from 'vue-draggable-resizable';
import 'vue-draggable-resizable/dist/VueDraggableResizable.css';
// import axios from 'axios';
import rundownItemsApi from '@/api/rundownItems';
import { duplicateVar } from '@/lib/helper';

export default {
	name: 'ElementZoom',
	props: {
		item: {
			type: Object,
		},
		status: {
			type: String,
		},
	},
	components: {
		'vue-draggable-resizable': VueDraggableResizable,
	},
	data() {
		return {
			localItem: null,
			showIframeLive: true,
			showIframePreview: true,
			errorIframeLive: false,
			errorIframePreview: false,
			timeoutLive: null,
			timeoutPreview: null,
			timepastLive: false,
			timepastPreview: false,
		};
	},
	sockets: {
		connect() {
			// this.activateSocket();
		},
		force_play_item(data) {
			if (this.localItem.id === data.id) {
				this.localItem = duplicateVar(data);
			}
		},
	},
	created() {
		this.localItem = duplicateVar(this.item);
	},
	watch: {
		item() {
			if (this.item) {
				this.localItem = duplicateVar(this.item);
			}
		},
	},
	methods: {
		showOnLoadLive() {
			this.showIframeLive = true;
		},
		showOnLoadPreview() {
			this.showIframePreview = true;
		},
		checkUrlPreview() {
			this.timepastPreview = false;
			this.timeoutLive = setTimeout(() => {
				this.timepastPreview = true;
			}, 250);
			if (this.$refs.iframePreviewCustBrowser.attachEvent) {
				this.$refs.iframePreviewCustBrowser.attachEvent('onload', () => {
					if (this.timepastPreview) {
						this.showIframePreview = true;
						this.errorIframePreview = false;
					} else {
						this.errorIframePreview = true;
						window.parent.postMessage(JSON.stringify({ data: 'invalidiframe', url: this.url }), '*');
					}
				});
			} else {
				this.$refs.iframePreviewCustBrowser.onload = () => {
					if (this.timepastPreview) {
						this.errorIframePreview = false;
						this.showIframePreview = true;
					} else {
						this.errorIframePreview = true;
						window.parent.postMessage(JSON.stringify({ data: 'invalidiframe', url: this.url }), '*');
					}
				};
			}
		},
		checkUrlLive() {
			this.timepastLive = false;
			this.timeoutPreview = setTimeout(() => {
				this.timepastLive = true;
			}, 250);
			if (this.$refs.iframeLiveCustBrowser.attachEvent) {
				this.$refs.iframeLiveCustBrowser.attachEvent('onload', () => {
					if (this.timepastLive) {
						this.showIframeLive = true;
						this.errorIframeLive = false;
					} else {
						this.errorIframeLive = true;
						window.parent.postMessage(JSON.stringify({ data: 'invalidiframe', url: this.url }), '*');
					}
				});
			} else {
				this.$refs.iframeLiveCustBrowser.onload = () => {
					if (this.timepastLive) {
						this.errorIframeLive = false;
						this.showIframeLive = true;
					} else {
						this.errorIframeLive = true;
						window.parent.postMessage(JSON.stringify({ data: 'invalidiframe', url: this.url }), '*');
					}
				};
			}
		},
		savePosition(x, y) {
			const callback = () => {
			};
			const errorCallback = () => {
			};
			const content = duplicateVar(this.content);
			content.x = x;
			content.y = y;
			// eslint-disable-next-line no-restricted-globals
			if (!x || isNaN(x)) {
				content.x = 0;
			} else {
				content.x = x;
			}
			// eslint-disable-next-line no-restricted-globals
			if (!y || isNaN(y)) {
				content.y = 0;
			// eslint-disable-next-line no-restricted-globals
			} else {
				content.y = y;
			}
			content.position = 'custom';
			const params = {
				content: JSON.stringify(content),
				editPreview: 1,
			};
			rundownItemsApi.update(this.localItem.id, params, callback, errorCallback);
		},
		saveSize(x, y, w, h) {
			const callback = () => {
			};
			const errorCallback = () => {
			};
			const content = duplicateVar(this.content);
			content.x = x;
			content.y = y;
			content.width = w;
			content.height = h;
			content.position = 'custom';
			// eslint-disable-next-line no-restricted-globals
			if (!w || isNaN(w) || w < 75) {
				content.width = 75;
			} else {
				content.width = w;
			}
			if (!h || (h < 75 && !content.isRatio)) {
				content.height = 75;
			// eslint-disable-next-line no-restricted-globals
			} else if (!h || isNaN(h) || (h < 75 && content.isRatio)) {
				content.height = 42;
			} else {
				content.height = h;
			}
			// eslint-disable-next-line no-restricted-globals
			if (!x || isNaN(x)) {
				content.x = 0;
			} else {
				content.x = x;
			}
			// eslint-disable-next-line no-restricted-globals
			if (!y || isNaN(y)) {
				content.y = 0;
			// eslint-disable-next-line no-restricted-globals
			} else {
				content.y = y;
			}
			const params = {
				content: JSON.stringify(content),
				editPreview: 1,
			};
			rundownItemsApi.update(this.localItem.id, params, callback, errorCallback);
		},
		onDragstop(x, y) {
			this.savePosition(x, y);
		},
		onResizestop(left, top, w, h) {
			this.saveSize(left, top, w, h);
		},
		onDrag() {
		},
		onResize(x, y, width, height) {
			this.content.width = width;
			this.content.height = height;
		},
		onCompletePlay(itemId) {
			const callback = () => {
			};
			const errorCallback = () => {
			};
			rundownItemsApi.playLive(itemId, callback, errorCallback);
		},
	},
	beforeDestroy() {
		clearTimeout(this.timeoutLive);
		clearTimeout(this.timeoutPreview);
		this.timepastPreview = true;
		this.timepastLive = true;
		// if (this.status === 'live') {
		// 	if (this.content && this.content.onCompleteItem) {
		// 		this.onCompletePlay(this.content.onCompleteItem);
		// 	}
		// }
	},
	computed: {
		isLockRatio() {
			return this.content && this.content.isRatio ? this.content.isRatio : false;
		},
		customPageId() {
			return `page${this.localItem.slug}-${this.localItem.id}`;
		},
		content() {
			return this.localItem.content && this.localItem.content !== ''
				? JSON.parse(this.localItem.content) : {};
		},
		className() {
			return this.content.position ? this.content.position : '';
		},
		style() {
			const style = {};
			style.position = 'absolute';
			style.border = '0';
			style.zIndex = this.localItem.layer_index;
			const content = this.content;
			if (content.opacity) style.opacity = content.opacity;
			return style;
		},
		styleWithCroppingOuter() {
			const style = {};
			style.zIndex = this.localItem.layer_index;
			const content = this.content;
			if (content.opacity) style.opacity = content.opacity;
			if (content.width) style.width = `${content.width}px`;
			if (content.height) style.height = `${content.height}px`;
			if (content.isEnableBorder) {
				if (content.isEnableCrop) {
					const top = content.cropTop || 0;
					const bottom = content.cropBottom || 0;
					const left = content.cropLeft || 0;
					const right = content.cropRight || 0;
					style.display = 'inline-block';
					style.position = 'relative';
					style.boxSizing = 'border-box';
					style.background = content.borderColor || 0;
					style.clipPath = `inset(${top}px ${right}px ${bottom}px ${left}px)`;
					style.overflow = 'hidden';
				} else {
					style.display = 'inline-block';
					style.position = 'relative';
					style.boxSizing = 'border-box';
					style.background = content.borderColor || 0;
					style.clipPath = 'inset(0px 0px 0px 0px)';
					style.overflow = 'hidden';
				}
			}
			return style;
		},
		styleWithCropping() {
			const style = {};
			style.position = 'absolute';
			style.pointerEvents = 'none';
			style.zIndex = this.localItem.layer_index;
			const content = this.content;
			if (content.opacity) style.opacity = content.opacity;
			if (content.isEnableCrop) {
				const thickness = content.borderThickness || 0;
				if (content.width) style.width = `${content.width - (thickness * 2)}px`;
				if (content.height) style.height = `${content.height - (thickness * 2)}px`;
				style.position = 'absolute';
				const top = content.cropTop || 0;
				const bottom = content.cropBottom || 0;
				const left = content.cropLeft || 0;
				const right = content.cropRight || 0;
				style.left = `${thickness}px`;
				style.top = `${thickness}px`;
				style.clipPath = `inset(${top}px ${right}px ${bottom}px ${left}px)`;
			} else {
				const thickness = content.borderThickness || 0;
				if (content.width) style.width = `${content.width - (thickness * 2)}px`;
				if (content.height) style.height = `${content.height - (thickness * 2)}px`;
				style.position = 'absolute';
				style.left = `${thickness}px`;
				style.top = `${thickness}px`;
				style.clipPath = 'inset(0px 0px 0px 0px)';
			}
			return style;
		},
		styleOutlineLive() {
			const style = {};
			style.zIndex = this.localItem.layer_index;
			style.position = 'absolute';
			const content = this.content;
			if (content.opacity) style.opacity = content.opacity;
			if (content.width) style.width = `${content.width}px`;
			if (content.height) style.height = `${content.height}px`;
			if (content.y) style.top = `${content.y}px`;
			if (content.x) style.left = `${content.x}px`;
			return style;
		},
		styleLive() {
			const style = {};
			style.position = 'absolute';
			style.border = '0';
			style.zIndex = this.localItem.layer_index;
			const content = this.content;
			if (content) {
				if (content.opacity) style.opacity = content.opacity;
				if (content.width) style.width = `${content.width}px`;
				if (content.height) style.height = `${content.height}px`;
				if (content.y) style.top = `${content.y}px`;
				if (content.x) style.left = `${content.x}px`;
				if (content.isEnableCrop) {
					const thickness = content.borderThickness || 0;
					if (content.width) style.width = `${content.width - (thickness * 2)}px`;
					if (content.height) style.height = `${content.height - (thickness * 2)}px`;
					style.position = 'absolute';
					const top = content.cropTop || 0;
					const bottom = content.cropBottom || 0;
					const left = content.cropLeft || 0;
					const right = content.cropRight || 0;
					style.left = `${thickness}px`;
					style.top = `${thickness}px`;
					style.clipPath = `inset(${top}px ${right}px ${bottom}px ${left}px)`;
				} else {
					const thickness = content.borderThickness || 0;
					if (content.width) style.width = `${content.width - (thickness * 2)}px`;
					if (content.height) style.height = `${content.height - (thickness * 2)}px`;
					style.position = 'absolute';
					style.left = `${thickness}px`;
					style.top = `${thickness}px`;
					style.clipPath = 'inset(0px 0px 0px 0px)';
				}
			}
			return style;
		},
		isCustomBrowser() {
			return this.localItem.type === 'custom_page';
		},
		url() {
			let url = this.content.customPageUrl ? this.content.customPageUrl : '';
			// check youtube only
			if (url.includes('https://www.youtu') || url.includes('https://youtu')) {
				const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
				const match = url.match(regExp);
				// eslint-disable-next-line
				if (match && match[2].length == 11) {
					return `https://www.youtube.com/embed/${match[2]}?autoplay=1`;
				}
				return 'error';
			}
			// check vimeo only
			if (url.includes('https://vimeo')) {
				const regExp = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/;
				const match = url.match(regExp);
				// eslint-disable-next-line
				if (match) {
					return `https://player.vimeo.com/video/${match[5]}?autoplay=1`;
				}
				return 'error';
			}
			if (url.includes('https://player.vimeo')) url = `${url}?autoplay=1`;
			return url;
		},
		isShowLabel() {
			return this.content && this.content.isShowLabel ? this.content.isShowLabel : 0;
		},
	},
	mounted() {
		// if (this.status === 'live') {
		// 	this.checkUrlLive();
		// } else {
		// 	this.checkUrlPreview();
		// }
	},
};
</script>
